module.exports = __webpack_public_path__ + "img/Education.ed229d26.svg";